(function () {
  if (window.__wishlistInit) return; // evita duplicar listeners se o botão aparecer várias vezes na página
  window.__wishlistInit = true;

  var CUSTOMER_LOGGED_IN = window.__wishlistCustomerLoggedIn === true;
  var GUEST_KEY = 'wishlist_guest_items';

  // Endpoints via Shopify App Proxy — a identidade do cliente é garantida
  // pelo Shopify (logged_in_customer_id assinado), nunca enviada pelo browser.
  var API = '/apps/printar/wishlist';

  function apiCall(path, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json' }, opts.headers || {});
    return fetch(API + path, opts).then(function (r) {
      if (!r.ok) throw new Error('wishlist_api_error_' + r.status);
      return r.json();
    });
  }

  function keyOf(productId, variantId) {
    return productId + ':' + (variantId || 0);
  }

  function getGuestItems() {
    try { return JSON.parse(localStorage.getItem(GUEST_KEY)) || []; } catch (e) { return []; }
  }
  function setGuestItems(items) {
    try { localStorage.setItem(GUEST_KEY, JSON.stringify(items)); } catch (e) {}
  }

  var known = new Set(); // itens atualmente na wishlist (API para clientes, localStorage para convidados)

  function markButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      var k = keyOf(btn.dataset.productId, btn.dataset.variantId);
      var active = known.has(k);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  // Busca os dados de apresentação (título/imagem/preço/stock) de itens
  // guardados só como {product_id, variant_id, handle} no localStorage —
  // usa a mesma API pública que a página de produto usa.
  function enrichGuestItems(items) {
    return Promise.all(items.map(function (raw) {
      if (!raw.handle) return null;
      return fetch('/products/' + raw.handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error('not_found'); return r.json(); })
        .then(function (product) {
          var variant = (product.variants || []).find(function (v) { return v.id === raw.variant_id; })
            || product.variants[0];
          var image = (variant && variant.featured_image) ? variant.featured_image.src : product.featured_image;
          return {
            product_id: raw.product_id,
            variant_id: raw.variant_id,
            title: product.title,
            handle: product.handle,
            image: image,
            price: variant ? (variant.price / 100).toFixed(2) : null,
            available: variant ? variant.available : false,
          };
        })
        .catch(function () { return null; });
    })).then(function (results) { return results.filter(Boolean); });
  }

  function loadKnown() {
    if (!CUSTOMER_LOGGED_IN) {
      var guestItems = getGuestItems();
      known = new Set(guestItems.map(function (i) { return keyOf(i.product_id, i.variant_id); }));
      markButtons();
      return enrichGuestItems(guestItems);
    }

    // Cliente com sessão iniciada — funde primeiro o que ficou guardado como
    // convidado (se houver) antes de carregar a wishlist da conta.
    var guestItems = getGuestItems();
    var mergeStep = guestItems.length
      ? apiCall('/merge.php', {
          method: 'POST',
          body: JSON.stringify({
            items: guestItems.map(function (i) { return { product_id: i.product_id, variant_id: i.variant_id }; }),
          }),
        }).then(function () { setGuestItems([]); }).catch(function () {})
      : Promise.resolve();

    return mergeStep.then(function () {
      return apiCall('/list.php').then(function (data) {
        known = new Set((data.items || []).map(function (i) { return keyOf(i.product_id, i.variant_id); }));
        markButtons();
        return data.items || [];
      });
    });
  }

  function toggle(btn) {
    var productId = parseInt(btn.dataset.productId, 10);
    var variantId = parseInt(btn.dataset.variantId, 10) || 0;
    var handle = btn.dataset.productHandle || '';
    var k = keyOf(productId, variantId);
    var isActive = known.has(k);

    if (!CUSTOMER_LOGGED_IN) {
      var items = getGuestItems();
      if (isActive) {
        items = items.filter(function (i) { return keyOf(i.product_id, i.variant_id) !== k; });
        known.delete(k);
      } else {
        items.push({ product_id: productId, variant_id: variantId, handle: handle });
        known.add(k);
      }
      setGuestItems(items);
      markButtons();
      if (document.getElementById('wishlist-items')) {
        enrichGuestItems(items).then(renderPage);
      }
      return;
    }

    var endpoint = isActive ? '/remove.php' : '/add.php';
    btn.disabled = true;
    apiCall(endpoint, {
      method: 'POST',
      body: JSON.stringify({ product_id: productId, variant_id: variantId }),
    })
      .then(function () {
        if (isActive) known.delete(k); else known.add(k);
        markButtons();
        if (document.getElementById('wishlist-items')) {
          loadKnown().then(renderPage);
        }
      })
      .catch(function (e) { console.error('wishlist:', e); })
      .finally(function () { btn.disabled = false; });
  }

  function popAnimate(btn) {
    btn.classList.remove('wishlist-pop');
    void btn.offsetWidth; // força reflow, para a animação poder reiniciar em cliques seguidos
    btn.classList.add('wishlist-pop');
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('.wishlist-remove-btn');
    if (removeBtn) { e.preventDefault(); toggle(removeBtn); return; }

    var heartBtn = e.target.closest('.wishlist-btn');
    if (heartBtn) { e.preventDefault(); popAnimate(heartBtn); toggle(heartBtn); return; }

    var cartBtn = e.target.closest('.wishlist-add-to-cart');
    if (cartBtn) { e.preventDefault(); addToCart(cartBtn); }
  });

  function addToCart(btn) {
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'A adicionar...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (r) { if (!r.ok) throw new Error('cart_add_error'); return r.json(); })
      .then(function () {
        btn.textContent = 'Adicionado ✓';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {
        btn.textContent = 'Erro — tenta de novo';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
      });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fmtMoney(cents) {
    return (cents / 100).toFixed(2) + '€';
  }

  // Preço mostrado tal como a Shopify o calcula para este cliente (respeita
  // catálogos B2B nativos, se for esse o mecanismo usado) — vai-se buscar à
  // própria página de produto (Storefront), não à Admin API.
  function loadLivePrice(item, priceEl) {
    fetch('/products/' + item.handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variant = (product.variants || []).find(function (v) { return v.id === item.variant_id; })
          || product.variants[0];
        if (!variant) return;
        priceEl.textContent = fmtMoney(variant.price);
      })
      .catch(function () {});
  }

  function renderPage(items) {
    var list = document.getElementById('wishlist-items');
    var empty = document.getElementById('wishlist-empty');
    if (!list) return;

    list.dataset.loading = 'false';
    if (!items.length) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    list.innerHTML = items.map(function (item) {
      return (
        '<div class="wishlist-card card-wrapper product-card-wrapper underline-links-hover">' +
          '<button type="button" class="wishlist-remove-btn" data-product-id="' + item.product_id + '" data-variant-id="' + item.variant_id + '" aria-label="Remover dos favoritos" title="Remover dos favoritos">&times;</button>' +
          '<a href="/products/' + esc(item.handle) + '" class="full-unstyled-link">' +
            (item.image ? '<img src="' + esc(item.image) + '" loading="lazy" alt="' + esc(item.title) + '">' : '') +
            '<h3 class="card__heading h5">' + esc(item.title) + '</h3>' +
          '</a>' +
          '<div class="price"><div class="price__container"><div class="price__regular"><span class="price-item price-item--regular wishlist-live-price" data-handle="' + esc(item.handle) + '" data-variant-id="' + item.variant_id + '">&hellip;</span></div></div></div>' +
          (!item.available ? '<p class="wishlist-card__oos">Sem stock</p>' : '') +
          '<button type="button" class="wishlist-add-to-cart button button--primary" data-variant-id="' + item.variant_id + '"' + (item.available ? '' : ' disabled') + '>Adicionar ao carrinho</button>' +
        '</div>'
      );
    }).join('');

    list.querySelectorAll('.wishlist-live-price').forEach(function (el) {
      loadLivePrice({ handle: el.dataset.handle, variant_id: parseInt(el.dataset.variantId, 10) }, el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.wishlist-btn') || document.getElementById('wishlist-items')) {
      loadKnown().then(function (items) {
        if (document.getElementById('wishlist-items')) renderPage(items);
      });
    }
  });
})();
